import { get, post } from './base'

const groupApi = {
  // 查询成员被分配的号码（本人）
  // getFaxNumber() {
  //   return get('api/group/faxNumber')
  // },
  // 分配号码给成员
  allocateFaxNumber(memberUserId, faxNumberList) {
    return post('api/faxNumber/allocate', { memberUserId, faxNumberList })
  },

  /**
   * 删除团队成员
   * @param {string} memberUserId 用户ID
   */
  delete(memberUserId) {
    return post('api/group/member/delete', { memberUserId })
  },
  // 冻结团队成员
  lock(memberUserId) {
    return post('api/group/member/lock', { memberUserId })
  },
  // 激活团队成员
  unLock(memberUserId) {
    return post('api/group/member/unLock', { memberUserId })
  },
  // 邀请团队成员
  invite(memberEmail) {
    return post('api/group/member/invite', { memberEmail })
  },

  /**
   * 邀请团队成员并分配号码
   * @param {String} memberEmail 邮箱
   * @param {String[]} allocateFaxNumberList 号码列表
   */
  inviteAndAllocFaxNumber(memberEmail, allocateFaxNumberList) {
    return post('api/group/member/invite/v2', { memberEmail, allocateFaxNumberList })
  },

  // 重新邀请团队成员
  reInvite(memberEmail) {
    return post('api/group/member/reInvite', { memberEmail })
  },
  // 取消邀请团队成员
  cancleInvite(memberEmail) {
    return post('api/group/member/invite/cancel', { memberEmail })
  },
  // 查询团队成员列表
  list() {
    return get('api/group/member')
  },
  // 更新成员信息
  updateUserInfo(memberUserId, { note }) {
    return post('api/group/member/update', {
      groupMemberId: memberUserId,
      note: note,
    })
  },
  // 查询团队信息
  detail() {
    return get('api/group')
  },
}

export default groupApi
